import React, { useRef, useState } from 'react';
import { Button } from '@progress/kendo-react-buttons';
import { Popup } from '@progress/kendo-react-popup';

const EMOJIS = [
  '😀', '😄', '😁', '😆', '😅', '😂', '🙂', '😉', '😊', '😍',
  '😎', '🤔', '😐', '😴', '😇', '🥳', '😮', '😢', '😡', '👍',
  '👎', '👏', '🙌', '🙏', '💪', '👀', '🔥', '✨', '⭐', '❤️',
  '✅', '❌', '⚠️', '❓', '❗', '🚀', '🎉', '💡', '📌', '📎',
];

/**
 * Custom Editor toolbar tool that inserts emoji characters at the current
 * selection. Emojis are plain Unicode text, so they are preserved by
 * sanitizeHtml/stripHtml without any special handling.
 *
 * Kendo passes the ProseMirror `view` to every custom tool via props.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const EmojiTool = (props: any) => {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef<HTMLSpanElement | null>(null);
  const view = props.view;

  const insertEmoji = (emoji: string) => {
    setOpen(false);
    if (!view) {
      return;
    }
    const { state } = view;
    const tr = state.tr.insertText(emoji, state.selection.from, state.selection.to);
    view.dispatch(tr);
    view.focus();
  };

  return (
    <>
      <span ref={anchorRef} style={{ display: 'inline-flex' }}>
        <Button
          type='button'
          onClick={() => setOpen((prev) => !prev)}
          title='Insert emoji'
          disabled={!view}
          fillMode='flat'
          size='medium'
          className='k-editor-tool'
        >
          <span role='img' aria-label='emoji' style={{ fontSize: '1rem', lineHeight: 1 }}>
            😀
          </span>
        </Button>
      </span>
      <Popup anchor={anchorRef.current} show={open} popupClass='k-group' animate={false}>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(10, 1fr)',
            gap: 2,
            padding: 8,
            maxWidth: 320,
          }}
        >
          {EMOJIS.map((emoji) => (
            <button
              key={emoji}
              type='button'
              onClick={() => insertEmoji(emoji)}
              style={{
                border: 'none',
                background: 'transparent',
                cursor: 'pointer',
                fontSize: '1.1rem',
                lineHeight: 1.4,
                padding: 2,
              }}
            >
              {emoji}
            </button>
          ))}
        </div>
      </Popup>
    </>
  );
};

export default EmojiTool;
